"use client";

import dynamic from "next/dynamic";
import { useMemo } from "react";

export default function EarthCard({ className }: { className?: string }) {
    const Map = useMemo(
        () => dynamic(() => import("./EarthCardMapInner"), { ssr: false }),
        [],
    );

    return (
        <div
            className={`card overflow-hidden relative ${className ?? ""}`}
            style={{ height: "420px", background: "#050810" }}
        >
            <Map />
        </div>
    );
}
